import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { Menu as MenuIcon } from '@material-ui/icons'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'

import { useIsMobile } from '../utils'

const useStyles = makeStyles(theme => ({
  extraControl: {
    marginBottom: theme.spacing(-1),
    marginTop: theme.spacing(-1),
  },
  extraControlMobile: {
    marginBottom: theme.spacing(-1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(-1),
  },
  grow: {
    flexGrow: 1,
  },
  nav: {
    backgroundColor: theme.palette.lightGreen.main,
    padding: theme.spacing(1.5, 1.5),
    [theme.breakpoints.up('mobile')]: {
      padding: theme.spacing(2, 1),
    },
    position: 'fixed',
    left: 0,
    right: 0,
    zIndex: 1,
  },
  navInner: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 auto',
    maxWidth: theme.maxWidth,
    [theme.breakpoints.up('mobile')]: {
      justifyContent: 'flex-start',
    },
  },
  link: {
    color: 'white',
    display: 'block',
    fontFamily: 'Gotham',
    fontWeight: 500,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    position: 'relative',
    textAlign: 'center',
    textDecoration: 'none',
    textTransform: 'uppercase',
    '&:hover::after, &.link-active::after': {
      content: '""',
      display: 'block',
      width: 8,
      height: 8,
      borderRadius: 7.5,
      backgroundColor: 'white',
      position: 'absolute',
      bottom: theme.spacing(-1.5),
      left: '50%',
      willChange: 'transform',
      transform: 'translate(-50%, -50%)',
    },
  },
  menuIcon: {
    color: 'white',
  },
  mobileNavLink: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
  },
  pageTitle: {
    color: 'white',
    fontFamily: 'Gotham',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
}))

const SecondaryNav = ({ extraControl, links, title }) => {
  const classes = useStyles()
  const isMobile = useIsMobile()

  // Mobile menu
  const [anchorEl, setAnchorEl] = useState(null)
  const handleOpenMenu = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  return (
    <div className={classes.nav}>
      {isMobile ? (
        <div className={classes.navInner}>
          <Typography className={classes.pageTitle}>{title}</Typography>
          <div className={classes.grow} />
          {extraControl && (
            <div className={classes.extraControlMobile}>{extraControl}</div>
          )}
          <IconButton
            className={classes.menuIcon}
            onClick={handleOpenMenu}
            size="small"
          >
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            getContentAnchorEl={null}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            {links.map(({ text, to }, idx) => (
              <MenuLink
                key={idx}
                onCloseMenu={handleCloseMenu}
                to={to}
                className={classes.mobileNavLink}
                text={text}
              />
            ))}
          </Menu>
        </div>
      ) : (
        <div className={classes.navInner}>
          {extraControl && (
            <div className={classes.extraControl}>{extraControl}</div>
          )}
          {links.map(({ text, ...props }, idx) => (
            <NavLink
              activeClassName="link-active"
              key={idx}
              className={classes.link}
              {...props}
            >
              {text}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  )
}

const MenuLink = React.forwardRef(
  ({ className, onCloseMenu, to, text, ...props }, ref) => (
    <Link to={to} className={className}>
      <MenuItem onClick={onCloseMenu} ref={ref} {...props}>
        {text}
      </MenuItem>
    </Link>
  )
)

SecondaryNav.propTypes = {
  extraControl: PropTypes.object,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      to: PropTypes.string,
    })
  ),
  title: PropTypes.string,
}

export default SecondaryNav
